import React, { useState } from 'react';
import { Input, Checkbox } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { decodeSpecLetters } from '../../../../Utility/utility';
import { BikerBedIcon, BikerClubIcon } from '../../../MainMenu/svg';
import { accessType } from '../../../../../constants/tourAccessibilityTypes.constants';

const icon = {
  [accessType.MY_BIKE_CLUB_TYPE]: <BikerClubIcon />,
  [accessType.MY_BIKER_BED_TYPE]: <BikerBedIcon />,
};

export const ExtraTypePanel = ({
  data,
  handleChange,
  checkedClubs,
  isDataLoaded,
  ...props
}) => {
  const [filterVal, setFilterVal] = useState('');

  const filterList = ({ target }) => {
    setFilterVal(target.value);
  };

  const getList = () =>
    data.filter(({ title = '' }) =>
      title.toUpperCase().includes(filterVal.toUpperCase())
    );

  const getClass = () => (props.selected ? 'selected-sub-types' : '');

  return (
    <div
      style={{ position: 'relative' }}
      className={['select-settings', getClass()].join(' ')}
    >
      <label className="top-radio-list radio-style ant-radio-wrapper added-settings">
        <span>{icon[props.type]}</span>
        <span>{props.header}</span>
      </label>

      <Input
        className="search-collapse-input"
        onClick={(e) => e.stopPropagation()}
        onChange={filterList}
        suffix={<SearchOutlined />}
        onPressEnter={(e) => e.stopPropagation()}
        allowClear
      />
      <div className="entity-list-wrapper">
        <Checkbox.Group
          onChange={(e) => handleChange(e, props.type)}
          className="sub-checkbox-list"
          value={checkedClubs}
        >
          {data && isDataLoaded && data.length === 0 ? (
            <span style={{ color: '#777777', margin: '0 40px' }}>
              {props.emptyListText}
            </span>
          ) : (
            getList().map(({ id, img, name, title, image, photo }) => (
              <Checkbox className="check-box-style" value={id} key={id}>
                <img
                  className="list-item-img"
                  src={img || image || photo}
                  width="20"
                  height="20"
                  alt="i"
                />
                <div className="list-item-title">
                  {decodeSpecLetters(name || title)}
                </div>
              </Checkbox>
            ))
          )}
        </Checkbox.Group>
      </div>
    </div>
  );
};
